import { render, staticRenderFns } from "./SelectProductDialog.vue?vue&type=template&id=1c8108b0&scoped=true"
import script from "./SelectProductDialog.vue?vue&type=script&lang=js"
export * from "./SelectProductDialog.vue?vue&type=script&lang=js"
import style0 from "./SelectProductDialog.vue?vue&type=style&index=0&id=1c8108b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8108b0",
  null
  
)

export default component.exports